import { useMutation } from 'react-query';
import { useZoneContext } from '../../../../contexts/useZoneContext';

export const useCaseExpertDeleteMutation = (onError?: (errorMessage: string) => void) => {
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (expertGuid: string) => {
            const response = await zoneApiClient.deleteCaseExpert(expertGuid);

            if (!response?.httpResponse.ok) {
                throw new Error('Failed to delete Case Expert');
            }

            return response;
        },
        onError(error) {
            if (error instanceof Error) {
                onError?.(error.message);
            }
        },
    });
}
